import React from 'react';
import { TooltipRenderProps, Step } from 'react-joyride';

import { Container, InfoArea } from '../styles';

interface Props {
  tooltipProps: any;
  step: Step;
  primaryProps: any;
}

const Tooltip: React.FunctionComponent<TooltipRenderProps> = ({ tooltipProps, step, primaryProps }: Props) => (
  <Container {...tooltipProps} onClick={primaryProps.onClick}>
    <InfoArea width={242}>
      <img src="/images/advice.svg" alt="Advice" />
      <p>{step.content}</p>
    </InfoArea>
  </Container>
);

export default Tooltip;
